// Sidebar accordion initialization
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".sidebar .nav-link").forEach(function (element) {
    element.addEventListener("click", function (e) {
      let nextEl = element.nextElementSibling;
      let parentEl = element.parentElement;

      if (nextEl) {
        e.preventDefault();
        let mycollapse = new bootstrap.Collapse(nextEl);

        if (nextEl.classList.contains("show")) {
          mycollapse.hide();
        } else {
          mycollapse.show();
          // find other submenus with class=show
          var opened_submenu =
            parentEl.parentElement.querySelector(".submenu.show");
          // if it exists, then close all of them
          if (opened_submenu) {
            new bootstrap.Collapse(opened_submenu);
          }
        }
      }
    });
  });
});
// DOMContentLoaded  end

// Hide list elements in sidebar list for small devices
// Selecciona todos los elementos li que contienen un elemento anidado con la clase "collapse"
var collapsibleLiElements = document.querySelectorAll("li:has(.collapse)");

// Itera a través de cada elemento y establece su propiedad "display" en "none" si se encuentra en un dispositivo móvil
collapsibleLiElements.forEach(function (li) {
  if (window.innerWidth < 768) {
    // Revisa si el ancho de la ventana es menor que 768px (es decir, un dispositivo móvil)
    li.style.display = "none";
  }
});

// Hide inactive accordion sections on click

const accordionButtons = document.querySelectorAll(".accordion-button");

accordionButtons.forEach((button) => {
  button.addEventListener("click", () => {
    const panels = document.querySelectorAll(".accordion-collapse");
    panels.forEach((panel) => {
      if (panel.classList.contains("show")) {
        panel.classList.remove("show");
      }
    });
  });
});

// full clickable card
// Selecciona la tarjeta por su ID
// Obtén todas las tarjetas de la página
const tarjetas = document.querySelectorAll(".card");

// Agrega un escucha de eventos para cada tarjeta
tarjetas.forEach((tarjeta) => {
  tarjeta.addEventListener("click", () => {
    // Obtiene la URL del enlace dentro de .verProyecto
    const url = tarjeta.querySelector(".verProyecto").href;

    // Redirige al usuario a la URL correspondiente
    window.location.href = url;
  });
});

// Animations on scroll for underline, circle on evidencia cientifica and CROssdata image
const observer = new IntersectionObserver((entries) => {
  // Loop over the entries
  entries.forEach((entry) => {
    // If the element is visible
    if (entry.isIntersecting) {
      // Add the animation class
      entry.target.classList.add("square-animation");
    }
  });
});

observer.observe(document.querySelector(".introProjects"));

// square.classList.remove('underlined--thick');

const observer2 = new IntersectionObserver((entries) => {
  // Loop over the entries
  entries.forEach((entry) => {
    // If the element is visible
    if (entry.isIntersecting) {
      // Add the animation class
      entry.target.classList.add("showUnderline");
    } else {
      // Si no es visible, eliminar la clase
      entry.target.classList.remove("showUnderline");
    }
  });
});

observer2.observe(document.querySelector(".underlined--thick"));

const elementosAnimados = document.querySelectorAll(".encerclat");
const opcionesObservador = {
  rootMargin: "0px",
  threshold: 0.2,
};

const animarElemento = function (elemento) {
  if (!elemento.animado) {
    setTimeout(() => {
      elemento.classList.add("encerclatAnimate");
    }, 700); // espera 10 segundos antes de aplicar la animación
    elemento.animado = true;
  } else {
    // Si no es visible, eliminar la clase
    elemento.classList.remove("encerclatAnimate");
    elemento.animado = false;
  }
};

const callbackObservador = function (entradas, parametroObservado) {
  entradas.forEach((entrada) => {
    if (entrada.isIntersecting) {
      animarElemento(entrada.target);
    }
  });
};

const parametroObservado = new IntersectionObserver(
  callbackObservador,
  opcionesObservador
);

elementosAnimados.forEach((elemento) => {
  parametroObservado.observe(elemento);
});

// Seleccionar la imagen a animar
const imagen = document.querySelector(".imagen-oculta");

// Crear una nueva instancia de IntersectionObserver
const observer5 = new IntersectionObserver((entradas) => {
  // Para cada entrada en la lista de entradas
  entradas.forEach((entrada) => {
    // Si la entrada es visible
    if (entrada.isIntersecting) {
      // Agregar la clase para activar la animación
      imagen.classList.add("imagen-mostrada");
      // Definir el tiempo de espera para la animación
      let tiempoEspera = 100;
      // Iterar sobre los polígonos del clip-path para activar la animación gradual
      for (let i = 0; i < 101; i++) {
        setTimeout(() => {
          let poligono = `polygon(0 0, ${i}% 0, ${i}% 100%, 0 100%)`;
          imagen.style.clipPath = poligono;
        }, tiempoEspera);
        tiempoEspera += 10;
      }
    } else {
      // Si no es visible, eliminar la clase
      imagen.classList.remove("imagen-mostrada");
      imagen.style.clipPath = "polygon(0 0, 0 100%, 0 100%, 0 100%)";
    }
  });
});

// Observar la imagen
observer5.observe(imagen);

// Active top navigation link  selection
(function () {
  var current = location.pathname.split("/")[1];
  if (current === "") return;
  var menuItems = document.querySelectorAll(".nav-item a");
  for (var i = 0, len = menuItems.length; i < len; i++) {
    if (menuItems[i].getAttribute("href").indexOf(current) !== -1) {
      menuItems[i].className += " activeNavLink";
    }
  }
  var menuItems = document.querySelectorAll(".logosFooter a");
  for (var i = 0, len = menuItems.length; i < len; i++) {
    if (menuItems[i].getAttribute("href").indexOf(current) !== -1) {
      menuItems[i].className += " activeFooterLink";
    }
  }
})();

const observer6 = new IntersectionObserver((entries) => {
  // Loop over the entries
  entries.forEach((entry) => {
    // If the element is visible
    if (entry.isIntersecting) {
      // Add the animation class
      entry.target.classList.add("saludableCricleAnimation");
    } else {
      // Si no es visible, eliminar la clase
      entry.target.classList.remove("saludableCricleAnimation");
    }
  });
});

observer6.observe(document.querySelector(".evidenciaCirculo"));

// Masonry filterint code
var grid = document.querySelector(".gridContainer");
var msnry;

// element selectors
var imgAll = document.querySelectorAll(".grid-item");
var imgCreatividad = document.querySelectorAll(".creatividad");
var imgInfluence = document.querySelectorAll(".influence");
var imgCientificas = document.querySelectorAll(".cientificas");
var imgProduction = document.querySelectorAll(".production");

// buttons
const tabsUl = document.getElementById("buttonGroup");
const lis = tabsUl.children;
const gridItems = grid.children;

imagesLoaded(grid, function () {
  msnry = new Masonry(grid, {
    //options
    itemSelector: ".grid-item",
    columnWidth: ".grid-sizer",
    percentPosition: true,
  });
});

//element & class name
function toggleClass(parentElem, childElems, className) {
  for (let i = 0; i < childElems.length; i++) {
    if (childElems[i] == parentElem) {
      childElems[i].classList.add(className);
    } else {
      childElems[i].classList.remove(className);
    }
  }
}

function showImages(showImg) {
  for (let i = 0; i < imgAll.length; i++) {
    if (showImg.length == 0 || imgAll[i].classList.contains(...showImg)) {
      imgAll[i].style.display = "block";
      // console.log(i);
      // console.log(imgAll.length);
    } else {
      imgAll[i].style.display = "none";
    }
  }
}

function chiquita(seccion) {
  var X = document.getElementById("container");
  if (seccion != "influence" || seccion != "production") {
    X.style.height = "500px";
  } else {
    X.style.height = "200px";
  }
}

tabsUl.addEventListener("click", (event) => {
  let tabLi = event.target.parentNode;
  toggleClass(tabLi, lis, "is-active");

  // show all images
  if (event.target.id == "all") {
    showImages([]);
  }
  // show creatividad images
  if (event.target.id == "creatividad") {
    showImages(["creatividad"]);
  }
  // show influence images
  if (event.target.id == "influence") {
    showImages(["influence"]);
  }
  // show cientificas images
  if (event.target.id == "cientificas") {
    showImages(["cientificas"]);
  }
  // show production images
  if (event.target.id == "production") {
    showImages(["production"]);
  }
  msnry.layout();
});

grid.addEventListener("click", function (event) {
  let imgContainer = event.target.parentNode;
  toggleClass(imgContainer, gridItems, "grid-item__expanded");
  msnry.layout();
});
